/** Tooltip copy for Training settings labels — presentation only. */
export const TRAINING_SETTINGS_FIELD_HELP = {
  startDate: 'First day learners can access this training program.',
  completionDate: 'Target date by which learners should finish this training — used for compliance tracking and overdue status.',
  trainingTime: 'Estimated duration in minutes — shown to learners as expected completion time.',
  visible: 'When off, learners cannot see or launch this training even if the schedule is active.',
  mediaUrl: 'Direct link to the training video or SCORM package entry point. Upload a file or paste a hosted URL.',
  thumbnail: 'Preview image shown in the training list. Recommended: landscape JPG or PNG.',
};
